import { j as t } from "../../../node_modules/react/jsx-runtime.js";
import { memo as x } from "react";
import e from "../../atoms/Button/Button.js";
import { RenderButtons as b } from "./RenderButtons.js";
import r from "./Pagination.module.scss.js";
const j = ({
  onNext: c,
  onPrev: g,
  onJump: o,
  currentPage: a,
  disabled: i = !1,
  per_page: d,
  total_entries: f
}) => {
  const n = a === 1, s = Math.ceil(Number(f) / Number(d)), l = a === s, h = (v) => v === a ? r.active : "";
  return s < 2 ? /* @__PURE__ */ t.jsx("div", {}) : /* @__PURE__ */ t.jsx(
    "div",
    {
      className: r.pagination,
      "data-testid": "table-pagination",
      children: /* @__PURE__ */ t.jsxs("div", { className: r.buttonsWarper, children: [
        /* @__PURE__ */ t.jsx(
          e,
          {
            color: "neutral",
            variant: "ghost",
            leadingIcon: "chevron-left-double",
            onClick: () => o == null ? void 0 : o(1),
            disabled: i || n,
            testId: "go-to-first"
          }
        ),
        /* @__PURE__ */ t.jsx(
          e,
          {
            color: "neutral",
            variant: "ghost",
            leadingIcon: "chevron-left",
            testId: "Previous",
            onClick: g,
            disabled: i || n,
            style: n ? { borderRight: "1px solid #bfbfbf" } : {}
          }
        ),
        /* @__PURE__ */ t.jsx(
          b,
          {
            total_pages: s ?? 0,
            currentPage: a ?? 1,
            onJump: o,
            activePage: h,
            paginationStyles: r,
            disabled: i
          }
        ),
        /* @__PURE__ */ t.jsx(
          e,
          {
            color: "neutral",
            variant: "ghost",
            trailingIcon: "chevron-right",
            onClick: c,
            testId: "Next",
            disabled: i || l
          }
        ),
        /* @__PURE__ */ t.jsx(
          e,
          {
            color: "neutral",
            variant: "ghost",
            trailingIcon: "chevron-right-double",
            onClick: () => o == null ? void 0 : o(s ?? 0),
            disabled: i || l,
            testId: "go-to-last"
          }
        )
      ] })
    }
  );
}, u = x(j);
export {
  u as default
};
//# sourceMappingURL=Pagination.js.map
